import { create } from 'zustand';

interface StreamingStatusStore {
  isStreaming: boolean;
  connectionStatus: 'connected' | 'connecting' | 'disconnected' | 'error';
  error: string | null;
  setStreaming: (streaming: boolean) => void;
  setConnectionStatus: (status: 'connected' | 'connecting' | 'disconnected' | 'error') => void;
  setError: (error: string | null) => void;
}

export const useStreamingStatus = create<StreamingStatusStore>((set) => ({
  isStreaming: false,
  connectionStatus: 'disconnected',
  error: null,
  setStreaming: (streaming) => set({ isStreaming: streaming }),
  setConnectionStatus: (status) => set({ connectionStatus: status }),
  setError: (error) => set({ error }),
}));